//React
import React from "react";
import {
  NavLink,
} from "react-router-dom";

//Icon
import PersonIcon from '@material-ui/icons/Person';
import ChatIcon from '@material-ui/icons/Chat';
import HelpIcon from '@material-ui/icons/Help';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';





class Comp extends React.Component {
  render() {
    return (
      <div className='sub_menu'>
        <div className='outer'>
            <NavLink to="/my/" exact className='link' activeClassName="selected">
              <PersonIcon className='icon'/><div className='text'>プロフ</div>
            </NavLink>
            <NavLink to="/my/post/" className='link' activeClassName="selected">
              <ChatIcon className='icon' /><div className='text'>投稿</div>
            </NavLink>
            <NavLink
              to="/my/qa/question/"
              isActive={
                (match, location) => {
                  var regex = new RegExp(/my\/qa/);
                  if (regex.test(location.pathname)) {
                    return true;
                  }
                }
              }
              className='link'
              activeClassName="selected"
            >
              <HelpIcon className='icon' /><div className='text'>Q&A</div>
            </NavLink>
            <NavLink to="/my/personality/" className='link' activeClassName="selected">
              <AssignmentIndIcon className='icon' /><div className='text'>性格</div>
            </NavLink>
        </div>
      </div>
    )
  }
}

export default Comp;
